module.exports = __webpack_public_path__ + "img/fshrx25t.a2083df7.png";